import schema from "./schema";
import { useTable } from "@/react/components/table/useTable";
import { EMPTY_ARRAY } from "@/react/empty";
import TableComponent from "@/react/components/table/TableComponent";
import React from "react";
import columnDefinition from "./columnDefinition";

const columns = Object.freeze(columnDefinition());

const JobsTable = ({ jobs, isLoading, refetch }) => {
  const idKey = schema.fields.name.spec.key;

  const { table, filters, state } = useTable(
    jobs ?? EMPTY_ARRAY,
    columns,
    schema,
    idKey,
    {
      enableRowSelection: (row) => {
        return !row.original[idKey];
      },
    }
  );

  return (
    <TableComponent
      title="Jobs"
      schema={schema}
      isLoading={isLoading}
      onRefresh={refetch}
      table={table}
      filters={filters}
      mutations={{}}
      state={state}
    />
  );
};

export default JobsTable;
